import {
    useState,
    forwardRef,
    useImperativeHandle,
} from 'react'

const NoticeStateMinnesota = forwardRef(({ data, company, refToPrint }, ref) => {

    const [requestReceiptCopy, setRequestReceiptCopy] = useState(data?.requestReceiptCopy ?? false)

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            return {
                isValid: true,
                value: {
                    result: true,
                    requestReceiptCopy,
                },
            }
        },
    }))

    return (
        <div className="max-w-3xl mx-auto p-6 bg-white shadow-md rounded-2xl">
            < div ref={refToPrint} className="space-y-6 text-gray-900 text-base leading-relaxed w-full" >
                <h2 className="text-2xl font-bold">
                    NOTICE REGARDING INVESTIGATIVE CONSUMER REPORTS PER MINNESOTA LAW
                </h2>

                <p>
                    {company?.name}, the "Company," may obtain a consumer report from a third-party consumer reporting agency in connection
                    with your prospective or continued employment. This may include procurement of an investigative consumer report,
                    which may include information obtained through personal interviews. These reports may contain information regarding
                    your criminal history, social security verification, motor vehicle records ("driving records"), verification of your education
                    or employment history, or other background checks and which may include information concerning your character,
                    general reputation, personal characteristics or mode of living. The most common form of an investigative consumer
                    report in connection with your employment is a reference check through personal interviews with sources such as
                    your former employers and associates, and other information sources. You have the right, upon written request,
                    to receive a complete and accurate disclosure of the nature and scope of any consumer report.
                </p>

                <div className="flex items-start space-x-2">
                    <input
                        type="checkbox"
                        checked={requestReceiptCopy}
                        onChange={(event) => setRequestReceiptCopy(!requestReceiptCopy)}
                        id="report-copy-request"
                        className="mt-1"
                        required
                    />
                    <label htmlFor="report-copy-request" className="text-gray-900">
                        Please check this box to receive from{" "}
                        <a
                            href="https://verifiedid.co"
                            className="text-blue-600 underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            VerifiedID
                        </a>
                        ,{" "}
                        <a href="tel:+18887182597" className="text-blue-600 underline">
                            (888) 718-2597
                        </a>
                        , 11180 State Bridge Road, suite 303, Alpharetta, GA, 30022, USA,{" "}
                        <a
                            href="https://verifiedid.co"
                            className="text-blue-600 underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://verifiedid.co
                        </a>{" "}
                        a copy of any report furnished by VerifiedID to the Company pursuant to your authorization.
                    </label>
                </div>
            </div >
        </div >
    )

})

export default NoticeStateMinnesota
